<template>
    <section class="section-calculator">
        <h2>გამომთვლელი</h2>
        <div class="switch">
            <button class="active">ფასი</button>
            <!-- <button>ვალუტა</button> -->
        </div>

        <div class="calculator-inpout">
            <input type="text" v-model="inputs.weight" placeholder="წონა" />
            <span>კგ</span>
        </div>
        <div class="calculator-inpout">
            <input type="text" v-model="inputs.length" placeholder="სიგრძე" />
            <span>სმ</span>
        </div>
        <div class="calculator-inpout">
            <input type="text" v-model="inputs.width" placeholder="სიგანე" />
            <span>სმ</span>
        </div>

        <div class="calculator-inpout">
            <input type="text" v-model="inputs.height" placeholder="სიმაღლე" />
            <span>სმ</span>
        </div>

        <div class="d-flex align-items-center">
            <span class="full-price-text">ნივთის ღირებულება</span>
            <div class="spacer"></div>
            <div class="full-price">{{ countPriceRef }} $</div>
        </div>
    </section>
</template>

<script>
import {
    defineComponent,
    onBeforeMount,
    reactive,
    ref,
    watchEffect,
} from "@vue/composition-api";
import axios from "axios";
export default defineComponent({
    setup() {
        const inputs = reactive({
            weight: "",
            length: "",
            width: "",
            height: "",
        });
        const pricesRef = ref([]);
        const ratesRef = ref(null);
        const countPriceRef = ref(0);
        const prices = async () => {
            let res = null;
            try {
                res = await axios({
                    method: "get",
                    url: "/api/prices",
                });
                if (res.data.length > 0) {
                    pricesRef.value = res.data;
                }
            } catch (error) {
                console.log(error.response);
            }
        };
        const rates = async () => {
            let res = null;
            try {
                res = await axios({
                    method: "get",
                    url: "/api/rates",
                });
                if (res.data) {
                    ratesRef.value = res.data;
                }
            } catch (error) {
                console.log(error.response);
            }
        };

        onBeforeMount(async () => {
            await prices();
            await rates();
        });

        watchEffect(() => {
            if (
                (inputs.weight &&
                    inputs.weight > 20 &&
                    inputs.length &&
                    inputs.width &&
                    inputs.height) ||
                (!inputs.weight &&
                    inputs.length &&
                    inputs.width &&
                    inputs.height)
            ) {
                let result =
                    (inputs.length * inputs.width * inputs.height) / 6000;
                let kgPrice = pricesRef.value.find(
                    (e) =>
                        Number(result.toFixed(2)) >= e.from &&
                        Number(result.toFixed(2)) <= e.to
                );
                if (kgPrice) {
                    console.log(result);
                    let price = Number(kgPrice.amount) * Number(result);
                    price = (price * 100) / 100;
                    countPriceRef.value = price.toFixed(2);
                    return;
                }
            } else if (inputs.weight) {
                let kgPrice = pricesRef.value.find(
                    (e) =>
                        Number(inputs.weight) >= e.from &&
                        Number(inputs.weight) <= e.to
                );
                if (kgPrice) {
                    let price = Number(kgPrice.amount) * Number(inputs.weight);
                    price = (price * 100) / 100;
                    countPriceRef.value = price.toFixed(2);
                    return;
                }
            }

            countPriceRef.value = 0;
        });

        return {
            inputs,
            countPriceRef,
        };
    },
});
</script>
